<template>
    <div id="bayWindow" v-if="windowForm">
        <button id="close" class="el-icon-close"></button>
        <a :href="windowForm.address" target="_blank">
            <img :src="windowForm.picturePath" alt="">
            <h2>{{ windowForm.name }}</h2>
        </a>
    </div>
</template>

<script>
import { linkListPage } from '@/api/cms'
export default {
    data(){
        return {
            windowForm: ''
        }
    },
    mounted(){
        linkListPage({pageNum: 1, pageSize: 1, type: 2}).then(res => {
            if(res.list.length && res.list[0].status == 1){
                this.windowForm = res.list[0]

                window.onload=function(){
                    //写入
                    var oneInner = document.getElementById("bayWindow");
                    var oneButton = document.getElementById("close");

                    //定时器
                    var a1a = setInterval(moves,80);
                    //函数

                    var x = 10;
                    var y = 10;

                    function moves(){
                        var tops = oneInner.offsetTop
                        var lefts = oneInner.offsetLeft
                        if (lefts>=document.documentElement.clientWidth-oneInner.offsetWidth||lefts<=0){
                            x=-x
                        }

                        if (tops>=document.documentElement.clientHeight-oneInner.offsetHeight||tops<=0){
                            y=-y
                        }

                        tops+=y;
                        lefts+=x;

                        oneInner.style.top=tops+"px"
                        oneInner.style.left=lefts+"px"
                    }

                    //悬停停止
                    oneInner.onmouseover=function(){
                        clearInterval(a1a);
                    }
                    //放手继续运动
                    oneInner.onmouseout=function(){
                        a1a =setInterval(moves,80);
                    }
                    //删除
                    oneButton.onclick=function(){
                        document.getElementById('app').removeChild(oneInner);
                    }
                }
            }
        })
    },
    methods: {
        
    },
}
</script>

<style scoped>
    #bayWindow{background:#fff;position:fixed;left:1px;top:1px;width:150px;max-height:300px;overflow: hidden;cursor:pointer;transition:all 0.08s linear;z-index:999;border: 1px solid #eee;}
    #bayWindow img{display: block;width: 100%;}
    #bayWindow h2{font-size: 14px;line-height: 22px;padding: 5px;}
    #bayWindow button{position: absolute;right: 3px;top: 3px;width: 18px;height: 18px;background: #000;border:0;outline: none;color: #fff;font-size: 12px;font-weight: 100;cursor: pointer;border-radius: 50%;opacity: 0.4;padding: 0;}
</style>